import type { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';

import Body from '@virtuslab/nfs-shared/src/components/molecules/Body';
import NavButton from '@virtuslab/nfs-shared/src/components/molecules/NavButton';
import ProfileLink from '@virtuslab/nfs-shared/src/components/molecules/ProfileLink';
import type { NavItem } from '@virtuslab/nfs-shared/src/config/navigation';
import { isEmpty } from '@virtuslab/nfs-shared/src/services/checks';

import useContract from '../../../services/hooks/useContract';

type Props = Readonly<{
  navigation: NavItem[];
}>;

const UserProfileLink = ({ navigation }: Props): ReactElement => {
  const { t } = useTranslation();

  const { contracts } = useContract();

  return (
    <ProfileLink
      caption={!isEmpty(contracts) ? undefined : (
        <Body size={200} variant="secondary">
          {t('No contract')}
        </Body>
      )}
      navigation={navigation.map((item) => (
        <NavButton item={item} key={item.id} />
      ))}
    />
  );
};

export default UserProfileLink;
